import Swal from "sweetalert2";

/*
opções icon:
  success
  error
  warning
  info
  question
*/

const defaultValues = {
  title: "Oops...",
  text: "Mensagem",
  icon: "error",
  footer: null
};

export default function alertInformacao(props) {
  Swal.fire({...defaultValues, ...props}).then((result) => {
    if (result.isConfirmed) {
      if (props.callback) {
        props.callback();
      }
    }
  });;
}
